<template>
    <div class="k-btn-toggle mx-auto text-center py-1 px-2 top-btn-toggle-sticky ">
        <v-btn-toggle v-model="selectedValue" mandatory required class="btn-toggle w-100">
            <v-btn v-for="(item, index) in items" :key="item.value" :value="item.value" :class="buttonClass">
                {{ item.label }}
            </v-btn>
        </v-btn-toggle>
    </div>
</template>

<script>
export default {
    name: 'BtnToggle',
    props: {
        items: {
            type: Array,
            required: true,
        },
        value: {
            type: String,
            default: null,
        },
    },
    emits: ['update:value'],
    computed: {
        selectedValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('update:value', newValue);
            },
        },
        buttonClass() {
            const count = this.items.length;
            if (count === 1) return 'w-100';
            if (count === 2) return 'w-50';
            if (count === 3) return 'w-33';
            if (count === 4) return 'w-25';
            return 'w-auto'; // Default for other cases
        },
    },
};
</script>

<style scoped>
.k-btn-toggle {
    /* Style adjustments for the toggle container */
}

.btn-toggle {
    display: flex;
    justify-content: space-around;
}

.w-100 {
    width: 100%;
}

.w-50 {
    width: 50%;
}

.w-33 {
    width: 33.3%;
}

.w-25 {
    width: 25%;
}
</style>